import Vue from 'vue';
import i18n from '@/plugins/i18n';

const notify = ({ title, message, type }) => {
  Vue.notify({
    title,
    text: message,
    type,
  });
};

export const notifySuccess = (message, title) => {
  notify({ title, message, type: 'success' });
};

export const notifyError = (message, title) => {
  notify({ title, message, type: 'error' });
};

export const notifyWarn = (message, title) => {
  notify({ title, message, type: 'warn' });
};

export const notifyGeneralError = (error) => {
  const title = i18n.t('notification.error-text');
  const message = error.message ? error.message : i18n.t('notification.error', { attribute: error?.httpStatusCode });
  notify({ title, message, type: 'error' });
};
